import utils from "../../../utils/utils.js";

export default {
    // İlk sayfayı getirir ve listeyi değiştirir. pageSize verilmezse mevcut sayfa boyutu kullanılır.
    // dateFrom / dateTo ("yyyy-MM-dd") verilmezse tarih filtresi yoktur (arşiv yeni bir feed için açıldığında filtre sıfırlanır).
    async fetchFeedArchive(context, payload) {
        const pageSize = payload.pageSize || context.state.pageSize;
        const dateFrom = payload.dateFrom || null;
        const dateTo = payload.dateTo || null;

        context.commit("setLoading", true);

        try {
            const responseData = await utils.utility.fetch(archiveUrl(payload.feedId, payload.multiLanguage, 1, pageSize, dateFrom, dateTo), "GET", null, null);

            context.commit("setFeedArchive", {
                ...parsePage(responseData.data, 1, pageSize),
                feedId: payload.feedId,
                multiLanguage: payload.multiLanguage,
                dateFrom: dateFrom,
                dateTo: dateTo,
                append: false
            });
        } finally {
            context.commit("setLoading", false);
        }
    },
    // Sonraki sayfayı getirir ve mevcut listenin sonuna ekler (sonsuz yükleme). Aktif tarih filtresi korunur.
    async fetchNextFeedArchivePage(context) {
        const state = context.state;

        if (state.isLoading || (state.feedArchive?.length || 0) >= state.totalCount) {
            return;
        }

        const nextPage = state.pageNumber + 1;

        context.commit("setLoading", true);

        try {
            const responseData = await utils.utility.fetch(archiveUrl(state.feedId, state.multiLanguage, nextPage, state.pageSize, state.dateFrom, state.dateTo), "GET", null, null);

            context.commit("setFeedArchive", {
                ...parsePage(responseData.data, nextPage, state.pageSize),
                feedId: state.feedId,
                multiLanguage: state.multiLanguage,
                dateFrom: state.dateFrom,
                dateTo: state.dateTo,
                append: true
            });
        } finally {
            context.commit("setLoading", false);
        }
    }
}

function archiveUrl(feedId, multiLanguage, pageNumber, pageSize, dateFrom, dateTo) {
    let url = `api/Editor/GetFeedArchives?feedId=${feedId}&multiLanguage=${multiLanguage}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (dateFrom) {
        url += `&dateFrom=${dateFrom}`;
    }

    if (dateTo) {
        url += `&dateTo=${dateTo}`;
    }

    return url;
}

// API sayfalı ({ items, totalCount, ... }) döner; eski sürüm düz dizi döndüğü için ikisi de desteklenir.
function parsePage(data, pageNumber, pageSize) {
    if (Array.isArray(data)) {
        return { archives: data, totalCount: data.length, pageNumber: 1, pageSize: pageSize };
    }

    const items = data?.items || [];

    return {
        archives: items,
        totalCount: data?.totalCount ?? items.length,
        pageNumber: data?.pageNumber || pageNumber,
        pageSize: data?.pageSize || pageSize
    };
}
